/**
 * Second argument factory for `useLogger().pushEvent(...)`.
 * Keeps `{ eventName, category }` in one place so Sonar does not treat repeated
 * object literals across item types as duplicated lines.
 */
export type NrPushEventCategory =
  | 'test'
  | 'precheck'
  | 'navigation'
  | 'error'
  | 'consent'
  | 'onboarding'
  | 'proctoring'
  | 'validation'
  | 'audio';

export function nrEvent(
  eventName: string,
  category: NrPushEventCategory = 'test'
): { eventName: string; category: NrPushEventCategory } {
  return { eventName, category };
}
